const GenerateChecklistId = (vesselName, departmentName, checklistType, displayId) => {
  const vesselPrefix = vesselName?.slice(0, 3).toUpperCase() || "XXX";
  const departmentPrefix = departmentName?.charAt(0) || "X";
  const checklistTypePrefix = checklistType?.charAt(0) || "X";
  const year = new Date().getFullYear() || "YYYY";
  const formattedDisplayId = String(displayId).padStart(3, "0") || "000";

  return `${vesselPrefix}/${departmentPrefix}/${year}/${checklistTypePrefix}${formattedDisplayId}`;
};

export default GenerateChecklistId;
